import { render, staticRenderFns } from "./SequenceBuilder.vue?vue&type=template&id=d06b3bfc&scoped=true"
import script from "./SequenceBuilder.vue?vue&type=script&lang=js"
export * from "./SequenceBuilder.vue?vue&type=script&lang=js"
import style0 from "./SequenceBuilder.vue?vue&type=style&index=0&id=d06b3bfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06b3bfc",
  null
  
)

export default component.exports